import { render } from "./Home.vue?vue&type=template&id=b415ef48"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b415ef48&lang=css"

import exportComponent from "/home/abrakadobr/dev/nodejs/takatan/@bluep-js/example/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__